import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/Index.vue'
import NotFound from '../views/NotFound.vue'
import ItemDetail from '../views/ItemDetail.vue'
// import Resources from '../views/Resources.vue'
import SavedList from '../views/SavedList.vue'
import SharedList from '../views/SharedList.vue'
import FeaturedCollections from '../views/FeaturedCollections.vue'
import i18n from '../i18n'

Vue.use(VueRouter)


const routes = [
    {
        path: `/`,
        name: 'basic-search',
        component: Index,
        props: (route) => {
            return {
                params: route.query
            }
        }
    },
    {
        path: `/${i18n.messages[i18n.locale].routes.advanced_search}`,
        name: 'advanced-search',
        component: Index,
        props: (route) => { 
            return {
                advancedSearchUI: true,
                params: route.query
            }
        }
    },
    {
        path: `/${i18n.messages[i18n.locale].routes.collections}`,
        name: 'collections',
        component: FeaturedCollections
    },
    {
        path: `/${i18n.messages[i18n.locale].routes.saved_list}`,
        name: 'saved-list',
        component: SavedList,
        props: (route) => { 
            return {
                params: route.query
            }
        }
    },
    {
        path: `/${i18n.messages[i18n.locale].routes.shared_list}`,
        name: 'shared-list',
        component: SharedList,
        props: (route) => { 
            return {
                params: route.query
            }
        }
    },
    {
        path: `/artifact/:id`,
        name: 'artifact-detail',
        component: ItemDetail,
        props: (route) => { 
            return {
                params: route.query
            }
        }
    },
    {
        path: `/archive/:id`,
        name: 'archive-detail',
        component: ItemDetail,
        props: (route) => { 
            return {
                params: route.query
            }
        }
    },
    {
        path: "*",
        component: NotFound
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH+ '/',
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})

export default router